import { useState, useEffect, useContext } from "react";
import { DeviceType, ConfigProviderContext } from "fr-ito-web-react/react/esm";
import { isClient } from "@util/analytics/utils";

export const useViewportWidth = () => {
  const configProviderContext = useContext(ConfigProviderContext);
  const getWindowWidth = () => {
    if (isClient) {
      return window.innerWidth || 0;
    } else
      switch (configProviderContext?.deviceType) {
        case DeviceType.Desktop:
          return 1199;
        case DeviceType.Tablet:
          return 959;
        default:
          return 599;
      }
  };
  const [width, setWidth] = useState(getWindowWidth());
  useEffect(() => {
    if (!isClient) return undefined; // Avoid running on the server
    const handleResize = () => setWidth(getWindowWidth());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return width;
};
